<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 d-inline-block mb-0">{{ $t("migration.title") }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <card>
        <template slot="header">
          <h3 class="mb-0">{{ $t("migration.clear_title") }}</h3>
          <p class="text-muted small mb-0">
            {{ $t("migration.clear_help") }}
          </p>
        </template>

        <div class="form-group row">
          <div class="col-md-6">
            <base-input
              v-model="number"
              :label="$t('migration.number')"
              placeholder="0812345678"
              required
            >
            </base-input>
          </div>
        </div>

        <div class="text-right">
          <base-button
            type="danger"
            @click="confirmClear"
            :disabled="running || !number"
          >
            <i class="fa fa-trash mr-1"></i>
            {{ $t("migration.clear_button") }}
          </base-button>
        </div>

        <div v-if="steps.length > 0" class="mt-4">
          <h4>
            {{ $t("migration.result") }}
            <small class="text-muted">— {{ lastNumber }}</small>
            <span
              class="badge ml-2"
              :class="overallBadge"
            >{{ overallText }}</span>
          </h4>
          <el-table :data="steps" header-row-class-name="thead-light">
            <el-table-column
              :label="$t('migration.col_step')"
              prop="Step"
              min-width="140"
            ></el-table-column>
            <el-table-column
              :label="$t('migration.col_status')"
              min-width="120"
            >
              <template slot-scope="{ row }">
                <span class="badge" :class="statusBadge(row.Status)">
                  {{ row.Status }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('migration.col_code')"
              prop="Code"
              min-width="100"
            ></el-table-column>
            <el-table-column
              :label="$t('migration.col_detail')"
              prop="Detail"
              min-width="320"
            >
              <template slot-scope="{ row }">
                <small class="text-muted">{{ row.Detail }}</small>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </card>
    </div>

    <modal :show.sync="running" :show-close="false" modal-classes="modal-sm">
      <div class="text-center py-3">
        <i class="fa fa-spinner fa-spin fa-2x text-primary mb-2"></i>
        <h4 class="mb-1">{{ $t("migration.running") }}</h4>
        <p class="text-muted mb-0">{{ $t("migration.running_text") }}</p>
      </div>
    </modal>
  </div>
</template>

<script>
import { Table, TableColumn } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import Modal from "@/components/Modal";
import swal from "sweetalert2";
import { WebPortalService } from "../../resource";

export default {
  name: "migration-tools",
  components: {
    RouteBreadCrumb,
    Modal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      number: "",
      running: false,
      steps: [],
      lastNumber: "",
      overall: ""
    };
  },
  computed: {
    overallText() {
      if (this.overall === "ok") return this.$t("migration.overall_ok");
      if (this.overall === "partial") return this.$t("migration.overall_partial");
      return "";
    },
    overallBadge() {
      if (this.overall === "ok") return "badge-success";
      if (this.overall === "partial") return "badge-warning";
      return "badge-secondary";
    }
  },
  methods: {
    statusBadge(status) {
      if (status === "ok") return "badge-success";
      if (status === "skipped") return "badge-secondary";
      if (status === "error") return "badge-danger";
      return "badge-light";
    },
    async confirmClear() {
      const confirmed = await swal.fire({
        title: this.$t("migration.confirm_title"),
        text: this.$t("migration.confirm_text", { number: this.number }),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("migration.confirm_yes"),
        cancelButtonText: this.$t("close"),
        confirmButtonClass: "btn btn-danger btn-fill",
        cancelButtonClass: "btn btn-secondary btn-fill",
        buttonsStyling: false
      });
      if (!confirmed.value) return;
      this.runClear();
    },
    async runClear() {
      this.running = true;
      this.steps = [];
      try {
        const resp = await WebPortalService.MigrationClearV4({
          number: this.number
        });
        this.lastNumber = resp.data.Number || this.number;
        this.steps = resp.data.Steps || [];
        this.overall = resp.data.Status || "ok";
      } catch (err) {
        const detail =
          err && err.response && err.response.data
            ? err.response.data
            : { Msg: err.message };
        swal.fire({
          title: this.$t(detail.Msg || "migration.failed"),
          text: "",
          icon: "error",
          confirmButtonClass: "btn btn-danger btn-fill",
          buttonsStyling: false
        });
      } finally {
        this.running = false;
      }
    }
  }
};
</script>
